import { checkToken } from '@/modules/helpers/auth/';

export const adminGuard = async (to, from, next) => {
    const storage = localStorage;

    if (storage.length === 0) {
        next({ name: 'auth' })
        return;
    }

    const token = storage.getItem('token');

    if (typeof(token) === null) {
        next({ name: 'auth' })
        return;
    }

    const response = await checkToken();

    if (response.error) {
        localStorage.clear();
        next({ name: 'auth' });
        return;
    }

    next();
};